
define('tpl!ui/component/tpl/window', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"window-component\">\n    <div class=\"window-component-title-bar\">\n        <div class=\"window-component-title\">";
  if (helper = helpers.windowTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.windowTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n        <div class=\"window-component-controls\"> </div>\n    </div>\n    <div class=\"window-component-body\"></div>\n</div>\n";
  return buffer;
  });
});

